<div class="social-media-wrapper">
  <p class="social-desc">{{ "SOCIALS.DESCRIPTION" | translate }}</p>

  <div class="social-icons">
    <a href="https://www.instagram.com/nk_rijeka/" target="_blank" title="Instagram">
      <img src="img/rijeka/icons/instagram.svg" alt="Instagram"/>
    </a>

    <a href="https://www.youtube.com/hnkrijekasluzbeni" target="_blank" title="YouTube">
      <img src="img/rijeka/icons/youtube.svg" alt="YouTube"/>
    </a>

    <a href="https://www.facebook.com/nk.rijeka/" target="_blank" title="Facebook">
      <img src="img/rijeka/icons/facebook.svg" alt="Facebook"/>
    </a>

    <a href="https://x.com/nkrijeka" target="_blank" title="X">
      <img src="img/rijeka/icons/x.svg" alt="X"/>
    </a>
  </div>
</div>